var LeadModal = function (parameters) {
  this.parameters = parameters;

  this.formSelector = parameters.leadFormSelector == null ? (".nhs_RequestInfoForm") : parameters.leadFormSelector;
};

LeadModal.prototype = {
  initialize: function () {
    var self = this;
    this.checkCounts = 0;
    var form = jQuery(this.formSelector);
    const formElement = document.querySelector(this.formSelector);

    const phoneInput = form[0].querySelector('[name=Phone]');
    if (phoneInput && window.VMasker) {
      window.VMasker(phoneInput).maskPattern('(999) 999-9999');
    }

    var closeModalBtn = document.getElementById("nhs_closeModal");
    if (closeModalBtn) {
      closeModalBtn.addEventListener("click", function () {
        self.logFormAnalyticsEvent("CLOSE", "CONTACT");
      });
    }

    const legalTextElement = form[0].querySelector('[data-legal-text]');
    if (legalTextElement) {
      // this function is declared in GlobalResourcesMvc/Default/js/LeadForm/LeadForm.common.js
      // and available here because that other file is bundled with this file.
      setupShowMoreLegalText(legalTextElement);
    }

    jQuery(this.formSelector).on('change', "[name='International'], [name='LivesOutside']", function () {
      var zip = jQuery(this).closest('.nhs_RequestInfoForm').find("[id='Zip']");
      var errorZipTextContent = document.getElementById("nhs_ErrorForHoursZipCodeReg");
      if (jQuery(this).is(':checked')) {
        zip.attr("disabled", "disabled");
        zip.val("");
        zip.removeClass("nhs_Error");
        zip.removeClass("nhs_ErrorSpan");
        errorZipTextContent.textContent = "";
        jQuery(this).closest('.nhs_RequestInfoForm').find("label[for='Zip']").removeClass("nhs_ErrorLabel");
      } else {
        zip.removeAttr("disabled");
      }
    });

    jQuery(this.formSelector).on('keyup', '#Zip, #Name, #Email', function () {
      var control = jQuery(this);
      control.removeClass("nhs_Error");
      control.prev("label[for]").removeClass("nhs_ErrorLabel");
    });

    jQuery(this.formSelector).on('change', '#IncludeRecoComm', function () {
      if (jQuery(this).is(":checked") && self.checkCounts == 0) {
        if (NHS.Scripts.Helper.readCookie) {
          jQuery.googlepush('Lead Events', NHS.Scripts.Helper.readCookie('CTAName'), 'Option Checked - Send Me More');
          self.checkCounts++;
        }
      }
    });

    jQuery(this.formSelector).on('click', '#RequestBrochureDate', function () {
      jQuery.googlepush('Lead Events', NHS.Scripts.Helper.readCookie('CTAName'), 'Option Checked - Appointment Calendar');
    });


    form.find("#AppointmentDateTime").attr("disabled", "disabled");

    jQuery(this.formSelector).on("change", "input[type=checkbox]", function () {
      var control = jQuery(this);
      control.val(control.is(":checked"));
    });

    function onChangeRealtorAnswer(event) {
      let selectedOption = event.target.options ? event.target.options[event.target.selectedIndex] : event.target;
      if (event.target.options) {
        for (let element of event.target.options) {
          element.removeAttribute("selected");
        }
      }

      selectedOption.setAttribute("selected", "");
    };

    if (this.formSelector && document.querySelector(this.formSelector)) {
      document.querySelector(this.formSelector).addEventListener("change", (event) => {
        if (event.target.id === "nhs-real-agent") {
            onChangeRealtorAnswer(event);
        }
      });
    }

    jQuery(document.body).on("click", ".showLoginLink", function (event) {
      var modalContainer = event.target.closest(".nhs_ModalBox");

      var confirmationSection = modalContainer.querySelector(".nhs_confirmationLeadForm");
      confirmationSection.style.display = "none";

      var loginSection = modalContainer.querySelector(".nhs_LogInFormContent");
      var loginInputs = loginSection.querySelectorAll(".emailSignIn, .passwordSignIn");

      for (var i = 0; i < loginInputs.length; ++i) {
        //removes error classes
        loginInputs[i].className = loginInputs[i].className.replace(/\binput-validation-error\b/g, "");
      }

      var errorSection = modalContainer.querySelector(".validation-summary-errors");
      errorSection.style.display = "none";

      loginSection.style.display = "block";
    });

    jQuery(this.formSelector).on("click", ".nhs_FormButton", async function (event) {
      var element = this;
      var buttonForm = jQuery(element).closest('.nhs_RequestInfoForm');
      element.disabled = true;
      document.body.dispatchEvent(new CustomEvent('lead-button-pressed', {
        detail: {
          buttonName: this.dataset.buttonClicked
        }
      }));

      var valid = await formValidator.validateForm(buttonForm[0]);
      const leadForm = element.closest('#nhs_LeadForm');

      if (valid) {
        const reCaptchaToken = new window.NewHomeSource.ReCaptchaToken();
        reCaptchaToken.initialize(formElement);
        const isValidRecaptcha = await reCaptchaToken.validate();
        reCaptchaToken.unbindEvents();

        if (!isValidRecaptcha) {
          element.disabled = false;
          return;
        }

        document.body.dispatchEvent(new CustomEvent('valid-lead', {
          detail: {
            form: leadForm,
            formButton: element,
          }
        }));

        window.NewHomeSource.GuidGenerator.leadGuid = window.NewHomeSource.GuidGenerator.generateGUID();

        var buttonForm = jQuery(this).closest('.nhs_RequestInfoForm');
        const includeRecommendationsCommunities = leadForm.querySelector('#IncludeRecoComm');
        const realtorQuestionAnswerInput = leadForm.querySelector('[data-realtor-answer]')
        const selectedRealtorAnswerText = realtorQuestionAnswerInput && realtorQuestionAnswerInput.selectedIndex > 0
          ? realtorQuestionAnswerInput.options[realtorQuestionAnswerInput.selectedIndex].text : '';
        const realtorQuestionAnswerId = realtorQuestionAnswerInput
          ? realtorQuestionAnswerInput.options[realtorQuestionAnswerInput.selectedIndex].value : '';

        let dataset = this.dataset;

        let eventForSegment = {
          event: 'Lead Modal Form Submitted',
          eventType: 'segmentEvent',
          builder_id: dataset.builder_id,
          builder_name: dataset.builder_name,
          community_id: dataset.community,
          community_name: dataset.community_name,
          state: dataset.state,
          city: dataset.city,
          community_low_price: dataset.community_low_price,
          community_high_price: dataset.community_high_price,
          home_price: dataset.home_price,
          home_type: dataset.home_type,
          primary_image_url: dataset.primary_image_url,
          isIdentifyEvent: false,
          button_action: dataset.button_action,
          realtor_question: selectedRealtorAnswerText
        };
        document.body.dispatchEvent && document.body.dispatchEvent(new CustomEvent("trackOnDemandEvent", {
          detail: { data: eventForSegment }
        }));

        if (self.parameters.IsAskQuestion) {
          var action = (self.parameters.FromPage === "communitydetail" ? "Community" : "Home") +
            " - Ask the Builder a Question - CTA - Submit";
          jQuery.googlepush("Lead Events", action, "Ask Question");
        } else {
          jQuery.googlepush("Lead Events", "", "Submit Form - Get Brochure");
        }

        if (buttonForm.find("#RequestBrochureDate").val() !== undefined) {
          self.IsAppt = true;
        } else {
          self.IsAppt = false;
        }

        var requestedFromMediaViewer = (document.getElementById("nhs_fullViewerLeadForm") !== null &&
          typeof (document.getElementById("nhs_fullViewerLeadForm")) !== "undefined");

        var isRequestVirtualTour =
          self.parameters.AppointmentType === "vc" || self.parameters.AppointmentType === "vt";

        var data = buttonForm.find("input, textarea").serialize() +
          "&AppointmentDateTime=" +
          buttonForm.find("#RequestBrochureDate").val() +
          "&IsAskQuestion=" +
          self.parameters.IsAskQuestion +
          "&IsAppointment=" +
          self.IsAppt +
          "&RequestedFromGallery=" +
          requestedFromMediaViewer +
          "&IsSoldHome=" +
          self.parameters.IsSoldHome +
          "&Is55PlusLead=" +
          self.parameters.Is55PlusLead +
          "&IsRequestVirtualTour=" +
          isRequestVirtualTour +
          "&IsComingSoon=" +
          self.parameters.IsComingSoon + 
          "&IsSpotlight=" +
          dataset.is_spotlight;

        data = `${data}&HasUserOptedIntoRecommendationEmail=${includeRecommendationsCommunities && includeRecommendationsCommunities.checked}`;
        data = `${data}&RealtorQuestionAnswerId=${realtorQuestionAnswerId}`;
        data = `${data}&IsFullImageViewerLead=${this.dataset.isFullImageViewerLead}`;
        data = `${data}&Guid=${window.NewHomeSource.GuidGenerator.leadGuid}`;

        const comments = self.GetCommentsData(buttonForm[0]);
        if (comments) {
          data = `${data}&Comments=${comments}`;
        }

        var control = jQuery(this);
        var isCustomLocation = buttonForm.find("[name='IsCustomLocation']").val() === "true";
        data.IsCustomLocation = isCustomLocation;
        if (isCustomLocation) {
          var url = buttonForm.find("[name='AskQuestionUrl']").val();
          self.SendAskQuestionLead(control, data, url);
        } else {
            var action = self.parameters.postLeadSendFunc != null
              ? self.parameters.postLeadSendFunc
              : self.initializeRecoModal;

            const formData = new FormData(leadForm);
            const dataEntries = Object.fromEntries(formData.entries());
            const listingInfoElement = document.querySelector('[data-listing-name]');
            const listingName = listingInfoElement ? listingInfoElement.getAttribute('data-listing-name') : null;

            const disableBrochureElement = document.querySelector('[data-disable-brochure]');
            const disableBrochure = disableBrochureElement ? disableBrochureElement.getAttribute('data-disable-brochure') : null;

            const recommendedModalCommand = {
              MailAddress: dataEntries.Email,
              SpecId: dataEntries.SpecId,
              PlanId: dataEntries.PlanId,
              CommunityId: dataEntries.CommunityId,
              FromPage: dataEntries.FromPage,
              GenerateLeadFrom: dataEntries.GenerateLeadFrom,
              ButtonNameSource: dataEntries.ButtonNameSource,
              Phone: dataEntries.Phone,
              BuilderId: dataEntries.BuilderId,
              MarketId: dataEntries.MarketId,
              UserPostalCode: dataEntries.postal,
              Name: dataEntries.name,
              ListingName: listingName ,
              DisableBrochure: disableBrochure,
              LeadAction: dataEntries.LeadAction
            };

            // emit a new event with the response from the server.
            document.dispatchEvent(new CustomEvent("openRecommendedModal", {
              detail: { data: recommendedModalCommand }
            }));

            self.GeneralAjaxCallAction(control, data, self.parameters.BrochureUrl, action);

            document.body.dispatchEvent(new CustomEvent('onLeadPosted', {
              detail: {
                name: dataEntries.name,
                emailAddress: dataEntries.Email,
                phoneNumber: dataEntries.Phone,
                postalCode: dataEntries.postal,
                livesOutside: dataEntries.LivesOutside == 'true',
                realtorQuestionAnswer: realtorQuestionAnswerId,
                sendAlerts: includeRecommendationsCommunities ? includeRecommendationsCommunities.checked : null
              }
            }));
          }
      } else {
        var errorMessages = buttonForm[0].querySelectorAll(".nhs_ErrorSpan");
        for (var i = 0; i < errorMessages.length; i++) {
          errorMessages[i].style.display = "block";
        }
      }
      element.disabled = false;
    });
  },

  /**
  * throw the event to persona.js
  * @param {object} element Dom element with the data attributes required
  */
  sendSegmentEventFavorites: function (element) {
    if (!element || !window.NewHomeSource.UserCredentials) {
      return;
    }
    // if user is logged and if is free brochure, send the segment event
    const userSession = window.NewHomeSource.UserCredentials.isUserLogged() || false;

    if (userSession) {
      document.body.dispatchEvent &&
        document.body.dispatchEvent(new CustomEvent("trackIdentifySaveItems", {
          detail: { data: element }
        }));
    }
  },

  initializeRecoModal: function (element) {
    var self = this;
    if (jQuery("#nhs_RecoCommsBox").length > 0) {

      jQuery("#nhs_RecoCommsBox .nhs_RecoCommsCheckbox").change(function () {
        if (jQuery("#nhs_RecoCommsBox .nhs_RecoCommsCheckbox").is(":checked")) {
          jQuery(".nhs_ModalActions #nhs_GetFreeBrochure, [data-get-brochure]").removeClass("Inactive");
          jQuery(".nhs_ModalActions #nhs_GetFreeBrochure, [data-get-brochure]").removeAttr("disabled");
        } else {
          jQuery(".nhs_ModalActions #nhs_GetFreeBrochure, [data-get-brochure]").addClass("Inactive");
          jQuery(".nhs_ModalActions #nhs_GetFreeBrochure, [data-get-brochure]").attr("disabled", "disabled");
        }
      });

      var closeModalBtn = document.getElementById("nhs_closeModal");
      if (closeModalBtn) {
        closeModalBtn.addEventListener("click", function () {
          self.logFormAnalyticsEvent("CLOSE", "RECO");
        });
      }

      var recommendationBox = document.querySelectorAll('[data-recommended-checkbox]');
      recommendationBox.forEach((element) => {
        element.addEventListener('change', self.onRecommendationBoxChange);
      });
    }

    self.sendSegmentEventFavorites(element[0]);
  },

  onRecommendationBoxChange: function(event) {
    if (!event.target.checked) {
      document.body.dispatchEvent(new CustomEvent('onRecommendationUnCheck'));
    }
  },

  logFormAnalyticsEvent: function (action, label) {
    var jsonForFormEvents;
    var inputForGaForms = document.getElementById("FormAbandonmentEvents");

    if (inputForGaForms && inputForGaForms.value !== "" && window.ga) {
      jsonForFormEvents = JSON.parse(inputForGaForms.value);
      ga("gtm2.send", "event", "Form Abandonment", JSON.parse(jsonForFormEvents[0])[action], JSON.parse(jsonForFormEvents[1])[label]);
    }
  },

  GeneralAjaxCallAction: function (control, data, url, action) {
    var self = this;
    control.attr("disabled", "disabled");

    jQuery.ajax({
      url: url,
      type: "POST",
      data: data,
      success: function (html) {
        if (window.NewHomeSource.ModalLoader) {
          window.NewHomeSource.ModalLoader.resetIsModalLoadedFlag();
        }

        if (self.parameters.postLeadSendFunc != null || typeof html !== 'string') {
          if (typeof (action) != "undefined") {
             action.call(self, html);
          }
        }
        else if (typeof html === 'string') {
          const container = document.querySelector('[data-trackers-container]');

          if (container) {
            const fragment = document.createRange().createContextualFragment(html);
            container.innerHTML = '';
            container.append(fragment);
            container.style.display = 'none';
          }

          if (typeof (action)!= "undefined") {
              action.call(self, control);
          }

          document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
            detail: {
              data: {
                eventType: "GAEvent",
                price_reduction: '',
              }
            }
          }));
        }
      }, error: function () {
        control.removeAttr("disabled");
      }
    });
  },

  /**
    * Gets the additional information that should be included in the comment field for the on page form.
    * @param {element} form The form element.
    * @returns The information that should be appended to the comment field.
    */
  GetCommentsData: function (form) {
    const optionTextSelected = Array.from(form.querySelectorAll("[name='form-options']:checked")).map(x => x.dataset.comment).join(", ");

    if (optionTextSelected.length > 0) {
      return `Interested in: ${optionTextSelected}.`;
    }

    return optionTextSelected;
  },

  SendAskQuestionLead: function (control, data, url) {
    const self = this;
    control.attr("disabled", "disabled");
    jQuery.ajax({
      url: url,
      type: "POST",
      data: data,
      success: function (html) {
        if (window.NewHomeSource.ModalLoader) {
          window.NewHomeSource.ModalLoader.resetIsModalLoadedFlag();
        }
        self.sendSegmentEventFavorites(control[0]);
        jQuery("#nhs_ajaxContent").html(html);
        document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
          detail: {
            data: {
              eventType: "GAEvent",
              price_reduction: '',
            }
          }
        }));
      }
    });
  }
};

(function () {
  "use strict";

  if ("function" === typeof define && define.amd) {
    // If supports for AMD is available return the value to the AMD Loader
    // and to the global (window) object in case any JS module is expecting
    // the lazyLoad to exists on the window object.
    define('leadModal',[], function () {
      return LeadModal;
    });
  } else if ("object" === typeof exports) {
    // If supports for Common JS is available export the module
    // and pass is value to the global (window) object in case non Common JS code
    // is expected to work with this lazyLoad.
    module.exports = LeadModal;
  } else {
    // If not support for AMD or Common JS is available register the module in the global scope.

    if ("undefined" === typeof NHS || null === NHS) {
      NHS = {};
    }
    if ("undefined" === typeof NHS.Scripts || null === NHS.Scripts) {
      NHS.Scripts = {};
    }

    NHS.Scripts.LeadModal = LeadModal;
  }

  // polyfill for closest method
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
      var element = this;

      do {
        if (element.matches(s)) {
          return element;
        }
        element = element.parentElement || element.parentNode;
      } while (element !== null && element.nodeType === 1);

      return null;
    };
  }

  const observerOptions = {
    childList: true,
    subtree: true
  };

  function callback(mutations) {
    mutations.forEach((mutation) => {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) { continue; }

        if (node.matches('[data-thank-you-modal]') || node.closest('[data-thank-you-modal]') || node.querySelector('[data-thank-you-modal]')) {
          const button = node.querySelector('[data-back-to-search]');
          const isSearchPage = document.querySelector('#nhs_ResultList');
          const isBuilderShowcase = document.querySelector('[data-component="builder-showcase-data"]');
          const breadcrumb = document.querySelector('.nhs_Breadcrumb:not(.nhs_StateBreadcrumb)');
          const signInButton = node.querySelector('[data-sign-in]');

          if(signInButton){
            signInButton.addEventListener('click', () => {
              window.openedModal._hide();
              if (window.NewHomeSource && window.NewHomeSource.ModalLoader) {
                window.NewHomeSource.ModalLoader.hideModal();
              }
              window.auth0Dom.signIn({});
            });
          }

          // if it's a search page, close the modal instead of reloading the page
          if (isSearchPage) {
            button.addEventListener('click', (event) => {
              event.preventDefault();
              if (window.NewHomeSource && window.NewHomeSource.ModalLoader) {
                window.window.NewHomeSource.ModalLoader.hideModal();
              }
            });
          }

          // if there's no href, the user entered the detail page directly
          if (button && !button.href && breadcrumb) {
            const url = breadcrumb.href;
            button.href = url;
          }

          // if the page is builder showcase, hide the back to search CTA since we don't have a way of getting the previous SRP link
          if(button && isBuilderShowcase){
            button.parentElement.removeChild(button);
          }

        }
      }
    });
  }

  const observer = new MutationObserver(callback);
  observer.observe(document.documentElement, observerOptions);
}());

